// supportVisit.ts · v12.10.9.4 (#1365 where a VoiceSpectrum Support visit goes when it ends) · 2026-10-07 · VoiceSpectrum AI
// The entry link (Support Ops / Platform Ops › Open as VoiceSpectrum Support) carries, after the one-time code, the console
// page to go back to and the practice's name. Kept for this tab only. Leave -> straight back to the console; blocked by the
// practice or timed out -> a page that says so with a link back (never the plain sign-in page).
export interface SupportVisit { back: string; name: string; from: string }
const KEY = 'vs.supportVisit';

/** Only our own consoles (or a dev machine) - never an address someone slipped into a link. */
export function safeBack(url: string | null): string | null {
  if (!url) return null;
  try {
    const u = new URL(url);
    if (u.protocol !== 'https:' && u.hostname !== 'localhost' && u.hostname !== '127.0.0.1') return null;
    const h = u.hostname.toLowerCase();
    return h === 'localhost' || h === '127.0.0.1' || h === 'voicespectrum.ai' || h.endsWith('.voicespectrum.ai') ? u.toString() : null;
  } catch { return null; }
}

export function saveSupportVisit(v: SupportVisit): void {
  try { sessionStorage.setItem(KEY, JSON.stringify(v)); } catch { /* storage blocked */ }
}

export function readSupportVisit(): SupportVisit | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const v = JSON.parse(raw) as Partial<SupportVisit>;
    const back = safeBack(v.back ?? null);
    return back ? { back, name: v.name || 'The practice', from: v.from || 'the console' } : null;
  } catch { return null; }
}

export function clearSupportVisit(): void {
  try { sessionStorage.removeItem(KEY); } catch { /* storage blocked */ }
}
